import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  scrollbar-color: ${({ theme }) => theme.color.ui4} transparent;
  scrollbar-width: thin;
  ::-webkit-scrollbar {
    background-color: ${({ theme }) => theme.color.ui6};
    height:12px;
    width: 12px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.color.ui6};
  }
  ::-webkit-scrollbar-track:hover {
    background-color: ${({ theme }) => theme.color.ui6};
  }
  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.color.ui4};
    border: 4px solid ${({ theme }) => theme.color.ui6};
    border-radius: 12px;
  }
  ::-webkit-scrollbar-thumb:hover {
    border: 4px solid ${({ theme }) => theme.color.ui6};
  }
`;
